export const TOGGLE_SIDEBAR_NAV = "@@ui/interface/TOGGLE_SIDEBAR_NAV";

type InterfaceState = {
  navOpen: boolean;
};

const initialState = {
  navOpen: false,
};

const interfaceReducer = (
  state: InterfaceState = initialState,
  action: any
): InterfaceState => {
  switch (action.type) {
    case TOGGLE_SIDEBAR_NAV: {
      return {
        ...state,
        navOpen: !state.navOpen,
      };
    }
    default:
      return state;
  }
};
export default interfaceReducer;
